import { render, staticRenderFns } from "./SensitiveWordListPage.vue?vue&type=template&id=65496f97&"
import script from "./SensitiveWordListPage.vue?vue&type=script&lang=js&"
export * from "./SensitiveWordListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports